// @flow

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Datetime from 'react-datetime';

const dateConditionList = [
  'Equals',
  'Doesn\'t equal',
  'Is Less than',
  'Is Less than or equal to',
  'Is greater than',
  'Is greater than or equal to',
];

export const DateFilterHeaderCell = (props) => {
  const [data, setData] = useState(props.value);
  const [conditionIndex, setConditionIndex] = useState(props.conditionIndex);
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);

  const wrapperRef = useRef(null);
  const dateTime = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpenDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDateChange = (date) => {
    const { setFilter } = props;
    setData(date);
    setFilter({ data: date, conditionIndex, isOpenDropDown });
  };

  const handleCondition = (index) => {
    const { setFilter } = props;
    setConditionIndex(index);
    setFilter({ data, conditionIndex: index, isOpenDropDown });
  };

  const handleKeyDown = (e) => {
    e.preventDefault();
    if (e.key === 'Backspace' || e.key === 'Escape') {
      dateTime.current && dateTime.current.props.onChange('');
    }
  };

  const handleInputChange = (e) => { e.preventDefault(); };

  return (
    <th className="header-cell">
      <div className="header-cell-container has-filter" ref={wrapperRef}>
        <div className="date-picker-container">
          <Datetime
            value={data}
            dateFormat="MM/DD/YYYY"
            timeFormat={false}
            onChange={date => handleDateChange(date)}
            inputProps={{
              onChange: handleInputChange,
              onKeyDown: handleKeyDown,
            }}
            ref={dateTime}
          />
        </div>
        <ul className={classNames('dropdown-menu', isOpenDropDown && 'open')} role="menu">
          {
            dateConditionList.map((item, index) => (
              <li key={`sentfilter-condition-${index.toString()}`}>
                <a href={window.location.href} onClick={() => handleCondition(index)} className={classNames({ 'active-dropdown': index === conditionIndex })}>{item}</a>
              </li>
            ))
          }
        </ul>
      </div>
    </th>
  );
};

DateFilterHeaderCell.propTypes = {
  setFilter: PropTypes.func,
  value: PropTypes.any,
  conditionIndex: PropTypes.number,
};

DateFilterHeaderCell.defaultProps = {
  setFilter: () => {},
  value: '',
  conditionIndex: 0,
};

export default DateFilterHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Tables/DateFilterHeaderCell.js